import { format } from 'date-fns';
import { fr } from 'date-fns/locale/fr';

function formatTime(iso: string): string {
    return format(new Date(iso), 'HH:mm');
}

// @todo translate: appointment.block.button_label (RDV {date} - {time})
export function formatAppointmentButtonLabel(startAt: string): string {
    const day = format(new Date(startAt), 'd MMMM', { locale: fr });
    return `RDV ${day} - ${formatTime(startAt)}`;
}

export function formatAppointmentPopoverDate(startAt: string): string {
    const formatted = format(new Date(startAt), 'EEEE d MMMM yyyy', { locale: fr });
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
}

export function formatAppointmentTimeRange(startAt: string, endAt: string): string {
    return `${formatTime(startAt)} - ${formatTime(endAt)}`;
}
